import { AfterViewInit, Directive, Input, OnChanges, inject } from "@angular/core";
import { CerrixInputValidationErrorsDirective } from "./cerrix-input-validation-errors.directive";
import { CerrixInputValidation } from "./models/cerrix-input-validation.interface";

@Directive({
    selector: "[appValidationCannotBeBeforeDate]",
})
export class CerrixInputValidationCannotBeBeforeDateDirective
    implements CerrixInputValidation, OnChanges, AfterViewInit
{
    // The earliest allowed date; the field's own date is bound in, so any way it changes revalidates
    @Input() appValidationCannotBeBeforeDate: string | Date | null = null;
    @Input() dateValue: string | Date | null = null;
    @Input() errorKey = "cannotBeBeforeDate";
    @Input() beforeDateErrorMessage: string = "";
    @Input() errorPriority = 10;

    private errors = inject(CerrixInputValidationErrorsDirective, { optional: true });

    ngOnChanges() {
        this.validate();
    }

    ngAfterViewInit() {
        this.errors.register(this);
    }

    validate() {
        const before = startOfDay(this.appValidationCannotBeBeforeDate);
        const current = startOfDay(this.dateValue);

        // An empty or half-finished date on either side has nothing to compare yet
        if (isNaN(before) || isNaN(current) || current >= before) {
            this.errors?.remove(this.errorKey);
            return;
        }

        this.errors?.add({
            key: this.errorKey,
            message: this.beforeDateErrorMessage,
            priority: this.errorPriority,
        });
    }
}

function startOfDay(value: string | Date | null): number {
    if (!value) {
        return NaN;
    }
    return new Date(value).setHours(0, 0, 0, 0);
}
